import type { MenuProps as AntdMenuProps } from 'antd';
import { Menu as AntdMenu } from 'antd';
import type {
  MenuItemType as AntdMenuItemType,
  SubMenuType as AntdSubMenuType,
  MenuDividerType,
} from 'antd/es/menu/interface';

import type { TestProps } from '/imports/ui/components/shared';

export interface MenuItemType<K extends string> extends AntdMenuItemType, TestProps {
  key: K;
}

export interface SubMenuType<K extends string> extends AntdSubMenuType, TestProps {
  key: K;
}

export type ItemType<K extends string> = MenuItemType<K> | SubMenuType<K> | MenuDividerType | null;

export interface MenuProps<K extends string> extends Omit<
  AntdMenuProps,
  'onSelect' | 'onDeselect'
> {
  items?: Array<ItemType<K>>;
  openKeys?: Array<NoInfer<K>>;
  defaultSelectedKeys?: Array<NoInfer<K>>;
  selectedKeys?: Array<NoInfer<K>>;
}

export const Menu = <K extends string>(props: MenuProps<K>) => <AntdMenu {...props} />;
